import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { ErrorObject } from '../models';
import { ReusableActionsUtil } from '../utils/reusable-actions.util';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class BlendingErrorHandlerService extends AbstractErrorHandlerService {
	protected trackErrorMessage: string;

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		if (!error.sourceApplication) {
			error.sourceApplication = this.errorHelperService.getApplicationName();
		}
		let errorCodes = [];
		if (get(error, 'responseJson.errorCodes') && !Array.isArray(error.responseJson.errorCodes)) {
			errorCodes = Object.values(error.responseJson.errorCodes).map(error => error['errorCode']);
		} else {
			errorCodes = get(error, 'responseJson.errorCodes', []);
		}

		if (
			error instanceof ErrorObject && errorCodes.includes(ERROR_CODES.DEPTH_VIOLATION)
		) {
			this.errorMessage = this.contentService.get('DEPTH_VIOLATION_MESSAGE_BEFORE_ANALYSIS', ErrorDCR.DEPTH_VIOLATION_MESSAGE_BEFORE_ANALYSIS);
			this.errorSeverity = ERROR_SEVERITY.CRITICAL;

			const firstFailedPortfolio = get(error, 'responseJson.resultList', []).find(portfolio => Object.keys(error.responseJson.errorCodes).includes(portfolio.id));

			console.error('The portfolio(s) ' + Object.keys(error.responseJson.errorCodes) + ' have too many levels.');

			this.trackErrorMessage = 'portfoliodepthviolation';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			const dialogErrorMessage = this.buildErrorMessage();

			dialogErrorMessage.actions = ReusableActionsUtil.generateActions(
				firstFailedPortfolio,
				this.contentService.get('ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL', ErrorDCR.ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL),
				this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL)
			);
			this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);
		} else if (error instanceof ErrorObject && errorCodes.includes(ERROR_CODES.CIRCULAR_DEPENDENCY)) {
			this.errorMessage = this.contentService.get('BLEND_CIRC_ERROR_MESSAGE', ErrorDCR.BLEND_CIRC_ERROR_MESSAGE);
			this.errorSeverity = ERROR_SEVERITY.CRITICAL;

			const firstFailedPortfolio = get(error, 'responseJson.resultList', []).find(portfolio => Object.keys(error.responseJson.errorCodes).includes(portfolio.id));

			console.error('The portfolio(s) ' + Object.keys(error.responseJson.errorCodes) + ' are cyclic portfolio.');

			this.trackErrorMessage = 'portfoliocyclicportfolios';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			const dialogErrorMessage = this.buildErrorMessage();

			dialogErrorMessage.actions = ReusableActionsUtil.generateActions(
				firstFailedPortfolio,
				this.contentService.get('ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL', ErrorDCR.ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL),
				this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL)
			);
			this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
